import aab from './logos/aab.png';
import aab_cropped from './logos/aab_cropped.png';
import allianz from './logos/allianz.png';
import allianz_cropped from './logos/allianz_cropped.png';
import alteLeipziger from './logos/alteLeipziger.png';
import alteLeipziger_cropped from './logos/alteLeipziger_cropped.png';
import apoBank from './logos/apoBank.png';
import apoBank_cropped from './logos/apoBank_cropped.png';
import axa from './logos/axa.png';
import axa_cropped from './logos/axa_cropped.png';
import barmenia from './logos/barmenia.png';
import barmenia_cropped from './logos/barmenia_cropped.png';
import bausparkasseMainz from './logos/bausparkasseMainz.png';
import bausparkasseMainz_cropped from './logos/bausparkasseMainz_cropped.png';
import bbBank from './logos/bbBank.png';
import bbBank_cropped from './logos/bbBank_cropped.png';
import bhw from './logos/bhw.png';
import bhw_cropped from './logos/bhw_cropped.png';
import blskSpk from './logos/blskSpk.png';
import blskSpk_cropped from './logos/blskSpk_cropped.png';
import bwBank from './logos/bwBank.png';
import bwBank_cropped from './logos/bwBank_cropped.png';
import commerzbank from './logos/commerzbank.png';
import commerzbank_cropped from './logos/commerzbank_cropped.png';
import continentale from './logos/continentale.png';
import continentale_cropped from './logos/continentale_cropped.png';
import degussa from './logos/degussa.png';
import degussa_cropped from './logos/degussa_cropped.png';
import deutscheBank from './logos/deutscheBank.png';
import deutscheBank_cropped from './logos/deutscheBank_cropped.png';
import dkb from './logos/dkb.png';
import dkb_cropped from './logos/dkb_cropped.png';
import dsl from './logos/dsl.png';
import dsl_cropped from './logos/dsl_cropped.png';
import dzhyp from './logos/dzhyp.png';
import ergo from './logos/ergo.png';
import ergo_cropped from './logos/ergo_cropped.png';
import evangelischeBank from './logos/evangelischeBank.png';
import evangelischeBank_cropped from './logos/evangelischeBank_cropped.png';
import generali from './logos/generali.png';
import generali_cropped from './logos/generali_cropped.png';
import gladbacherBank from './logos/gladbacherBank.png';
import gladbacherBank_cropped from './logos/gladbacherBank_cropped.png';
import hannoversche from './logos/hannoversche.png';
import hannoversche_cropped from './logos/hannoversche_cropped.png';
import hanseatic from './logos/hanseatic.png';
import hanseatic_cropped from './logos/hanseatic_cropped.png';
import haspa from './logos/haspa.png';
import haspa_cropped from './logos/haspa_cropped.png';
import hausbankMuenchen from './logos/hausbankMuenchen.png';
import hausbankMuenchen_cropped from './logos/hausbankMuenchen_cropped.png';
import huk from './logos/huk.png';
import huk_cropped from './logos/huk_cropped.png';
import hypo from './logos/hypo.png';
import hypo_cropped from './logos/hypo_cropped.png';
import ing from './logos/ing.png';
import ing_cropped from './logos/ing_cropped.png';
import investitionsbankBerlin from './logos/investitionsbankBerlin.png';
import investitionsbankBerlin_cropped from './logos/investitionsbankBerlin_cropped.png';
import investitionsbankSh from './logos/investitionsbankSh.png';
import investitionsbankSh_cropped from './logos/investitionsbankSh_cropped.png';
import kfw from './logos/kfw.png';
import kfw_cropped from './logos/kfw_cropped.png';
import lbs from './logos/lbs.png';
import lbs_cropped from './logos/lbs_cropped.png';
import liga from './logos/liga.png';
import liga_cropped from './logos/liga_cropped.png';
import lloydsbank from './logos/lloydsbank.png';
import lloydsbank_cropped from './logos/lloydsbank_cropped.png';
import lvm from './logos/lvm.png';
import lvm_cropped from './logos/lvm_cropped.png';
import lzoSpk from './logos/lzoSpk.png';
import lzoSpk_cropped from './logos/lzoSpk_cropped.png';
import mhyp from './logos/mhyp.png';
import mhyp_cropped from './logos/mhyp_cropped.png';
import mlp from './logos/mlp.png';
import mlp_cropped from './logos/mlp_cropped.png';
import noLogo from './logos/noLogo.png';
import noLogo_cropped from './logos/noLogo_cropped.png';
import nordLb from './logos/nordLb.png';
import nordLb_cropped from './logos/nordLb_cropped.png';
import oldenburgLandesbank from './logos/oldenburgLandesbank.png';
import oldenburgLandesbank_cropped from './logos/oldenburgLandesbank_cropped.png';
import penka from './logos/penka.png';
import penka_cropped from './logos/penka_cropped.png';
import provinzial from './logos/provinzial.png';
import provinzial_cropped from './logos/provinzial_cropped.png';
import psd from './logos/psd.png';
import psd_cropped from './logos/psd_cropped.png';
import santander from './logos/santander.png';
import santander_cropped from './logos/santander_cropped.png';
import signalIduna from './logos/signalIduna.png';
import signalIduna_cropped from './logos/signalIduna_cropped.png';
import sparda from './logos/sparda.png';
import sparda_cropped from './logos/sparda_cropped.png';
import sparkasse from './logos/sparkasse.png';
import sparkasseLuebeck from './logos/sparkasseLuebeck.png';
import sparkasseLuebeck_cropped from './logos/sparkasseLuebeck_cropped.png';
import sparkasseMuenchen from './logos/sparkasseMuenchen.png';
import sparkasseMuenchen_cropped from './logos/sparkasseMuenchen_cropped.png';
import sparkasseVorpommern from './logos/sparkasseVorpommern.png';
import sparkasseVorpommern_cropped from './logos/sparkasseVorpommern_cropped.png';
import sparkasse_cropped from './logos/sparkasse_cropped.png';
import spk1822direkt from './logos/spk1822direkt.png';
import spk1822direkt_cropped from './logos/spk1822direkt_cropped.png';
import startbausparkasse from './logos/startbausparkasse.png';
import startbausparkasse_cropped from './logos/startbausparkasse_cropped.png';
import suedwestbank from './logos/suedwestbank.png';
import suedwestbank_cropped from './logos/suedwestbank_cropped.png';
import sv from './logos/sv.png';
import sv_cropped from './logos/sv_cropped.png';
import universa from './logos/universa.png';
import universa_cropped from './logos/universa_cropped.png';
import vkb from './logos/vkb.png';
import vkb_cropped from './logos/vkb_cropped.png';
import volksbank from './logos/volksbank.png';
import volksbank_cropped from './logos/volksbank_cropped.png';
import volkswohlBund from './logos/volkswohlBund.png';
import volkswohlBund_cropped from './logos/volkswohlBund_cropped.png';
import vrBankNiederbayern from './logos/vrBankNiederbayern.png';
import vrBankNiederbayern_cropped from './logos/vrBankNiederbayern_cropped.png';
import vzn from './logos/vzn.png';
import vzn_cropped from './logos/vzn_cropped.png';
import wuestenrot from './logos/wuestenrot.png';
import wuestenrot_cropped from './logos/wuestenrot_cropped.png';
const logos = {
  aab,
  aab_cropped,
  allianz,
  allianz_cropped,
  alteLeipziger,
  alteLeipziger_cropped,
  apoBank,
  apoBank_cropped,
  axa,
  axa_cropped,
  barmenia,
  barmenia_cropped,
  bausparkasseMainz,
  bausparkasseMainz_cropped,
  bbBank,
  bbBank_cropped,
  bhw,
  bhw_cropped,
  blskSpk,
  blskSpk_cropped,
  bwBank,
  bwBank_cropped,
  commerzbank,
  commerzbank_cropped,
  continentale,
  continentale_cropped,
  degussa,
  degussa_cropped,
  deutscheBank,
  deutscheBank_cropped,
  dkb,
  dkb_cropped,
  dsl,
  dsl_cropped,
  dzhyp,
  ergo,
  ergo_cropped,
  evangelischeBank,
  evangelischeBank_cropped,
  generali,
  generali_cropped,
  gladbacherBank,
  gladbacherBank_cropped,
  hannoversche,
  hannoversche_cropped,
  hanseatic,
  hanseatic_cropped,
  haspa,
  haspa_cropped,
  hausbankMuenchen,
  hausbankMuenchen_cropped,
  huk,
  huk_cropped,
  hypo,
  hypo_cropped,
  ing,
  ing_cropped,
  investitionsbankBerlin,
  investitionsbankBerlin_cropped,
  investitionsbankSh,
  investitionsbankSh_cropped,
  kfw,
  kfw_cropped,
  lbs,
  lbs_cropped,
  liga,
  liga_cropped,
  lloydsbank,
  lloydsbank_cropped,
  lvm,
  lvm_cropped,
  lzoSpk,
  lzoSpk_cropped,
  mhyp,
  mhyp_cropped,
  mlp,
  mlp_cropped,
  noLogo,
  noLogo_cropped,
  nordLb,
  nordLb_cropped,
  oldenburgLandesbank,
  oldenburgLandesbank_cropped,
  penka,
  penka_cropped,
  provinzial,
  provinzial_cropped,
  psd,
  psd_cropped,
  santander,
  santander_cropped,
  signalIduna,
  signalIduna_cropped,
  sparda,
  sparda_cropped,
  sparkasse,
  sparkasseLuebeck,
  sparkasseLuebeck_cropped,
  sparkasseMuenchen,
  sparkasseMuenchen_cropped,
  sparkasseVorpommern,
  sparkasseVorpommern_cropped,
  sparkasse_cropped,
  spk1822direkt,
  spk1822direkt_cropped,
  startbausparkasse,
  startbausparkasse_cropped,
  suedwestbank,
  suedwestbank_cropped,
  sv,
  sv_cropped,
  universa,
  universa_cropped,
  vkb,
  vkb_cropped,
  volksbank,
  volksbank_cropped,
  volkswohlBund,
  volkswohlBund_cropped,
  vrBankNiederbayern,
  vrBankNiederbayern_cropped,
  vzn,
  vzn_cropped,
  wuestenrot,
  wuestenrot_cropped
};
export default logos;